// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3171":"a60be3e1","4322":"51b53447"}[chunkId] + ".chunk.css";
};